import queryString from "query-string";

const FILTER_REGEX = /^f_.*$/;
const SORT_REGEX = /^s_.*$/;
const PAGINATION_REGEX = /^p_.*$/;

/**
 * @return query params of URL.
 */
export function getParams() {    
    return queryString.parse(window.location.search);
}


/**
 * @return query params which consist of pagination and filter keys.
 */
export function getSortAndFilterQueryString(page, size) {
    const newParams = {p_page: page, p_size: size}
    const params = getParams();
    for (const key in params) {
        if (key.startsWith('f_') || key.startsWith('s_')) {
            newParams[key] = params[key]
        }
    }
    return queryString.stringify(newParams);
}


export function getFilterQueryString() {
    const newParams = {};
    const params = getParams();
    for (const key in params) {
        if (key.startsWith('f_')) {
            newParams[key] = params[key]
        }
    }
    return queryString.stringify(newParams);
}
/**
 * @return query params without filter and pagination keys.
 */
export function getLayoutParams() {
    const params = getParams();    
    const result = Object.assign({});
    Object.keys(params)
        .filter(key => !FILTER_REGEX.test(key) && !SORT_REGEX.test(key) && !PAGINATION_REGEX.test(key))
        .forEach(key => result[key] = params[key]);
    return result;
}

/**
 * @return page title query param value.
 */
export function getPageTitle() {
    return getParams().pageTitle;
}

/**
 * @return page title query param value.
 */
export function getFilters(clean) {
    const params = getParams();
    const result = Object.assign({});
    Object.keys(params)
        .filter(key => FILTER_REGEX.test(key))
        .forEach(key => result[clean ? key.slice(2) : key] = params[key]);
    return result;
}

/**
 * @return sort from URL query params.
 */
export function getSort(clean) {
    const params = getParams();
    const result = Object.assign({});
    Object.keys(params)
        .filter(key => SORT_REGEX.test(key))
        .forEach(key => result[clean ? key.slice(2) : key] = params[key]);
    return result;
}

/**
 * Get the sorting param by name and changes the sort value.
 *
 * @param name - sort name.
 * @return {string} - query string.
 */

export function updateSort(name) {
    const sortKey = 's_' + name;
    const params = getLayoutParams();
    //alert (params);
    const filters = getFilters();
    let sort = getSort();
    //alert(sort.FILTER_REGEX);
    const current = sort[sortKey];
    const newSort = {[sortKey]: current === 'asc' ? 'desc' : 'asc'};
    return queryString.stringify({...params, ...filters, ...newSort})
}

/**
 * Replaces an existing filter or creates a new one.
 *
 * @param name - filter name
 * @param value - filter value
 * @return {string} - query string
 */
export function replaceFilters(name, value) {
    const filterKey = 'f_' + name;
    const params = getLayoutParams();
    const sort = getSort();
    const newFilter = {[filterKey]: value};
    return queryString.stringify({...params, ...newFilter, ...sort})
}

/**
 * Updates MSB table title and filter value at the same time.
 * Created to prevent double URL updating.
 *
 * @param filterKey - filter name.
 * @param filterValue - filter value.
 * @param tableTitle - table title.
 * @return {string} - query string.
 */
export function updateMsbTableParams(filterKey, filterValue, tableTitle) {
    const filter = 'f_' + filterKey;
    const params = getLayoutParams();
    const sort = getSort();
    const newFilter = {[filter]: filterValue};
    params.tableTitle = tableTitle;
    return queryString.stringify({...params, ...newFilter, ...sort})
}

/**
 * Get the filter param by name and changes the value.
 *
 * @param name - filter name.
 * @param value - filter value.
 * @return {string} - query string.
 */
export function updateFilters(name, value) {
    const filterKey = 'f_' + name;
    const params = getLayoutParams();
    const sort = getSort();
    const filters = getFilters();
    filters[filterKey] = value;    
    return queryString.stringify({...params, ...filters, ...sort})
}

export function updateSearchFilters(name, value) {

    const params = getLayoutParams();
    const sort = getSort();
    let filters = getFilters();

    let aryFilters=[];
    switch (name) {
        case 'valid':
            aryFilters = ['severity', 'rule', 'details'];
            filters = removeSearchFilters(aryFilters);
            break;                
        case 'severity':
            aryFilters = ['valid', 'rule', 'details'];
            filters = removeSearchFilters(aryFilters);
            break;
        case 'rule':
            aryFilters = ['severity', 'valid', 'details'];
            filters = removeSearchFilters(aryFilters);
            break;
        case 'details':
            aryFilters = ['severity', 'valid', 'rule'];
            filters = removeSearchFilters(aryFilters);
            break;
        case 'requireAttention':
            // aryFilters = ['severity', 'valid', 'rule', 'details'];
            // filters = removeSearchFilters(aryFilters);
            break;
        default:
            aryFilters = ['severity', 'valid', 'rule', 'details'];
            filters = removeSearchFilters(aryFilters);
            break;
    }

    const filterKey = 'f_' + name; 
    filters[filterKey] = value;    
    return queryString.stringify({...params, ...filters, ...sort})
}

export function addSearchFilters(name, value) {

    const params = getLayoutParams();
    const sort = getSort();
    let filters = getFilters();

    //let aryFilters=[];
    // switch (name) {
    //     case 'valid':
    //         aryFilters = ['severity', 'rule', 'details'];
    //         filters = removeSearchFilters(aryFilters);
    //         break;                
    //     case 'severity':
    //         aryFilters = ['valid', 'rule', 'details'];
    //         filters = removeSearchFilters(aryFilters);
    //         break;
    //     case 'rule':
    //         aryFilters = ['severity', 'valid', 'details'];
    //         filters = removeSearchFilters(aryFilters);
    //         break;
    //     case 'details':
    //         aryFilters = ['severity', 'valid', 'rule'];
    //         filters = removeSearchFilters(aryFilters);
    //         break;
    //     case 'requireAttention':
    //         // aryFilters = ['severity', 'valid', 'rule', 'details'];
    //         // filters = removeSearchFilters(aryFilters);
    //         break;
    //     default:
    //         aryFilters = ['severity', 'valid', 'rule', 'details'];
    //         filters = removeSearchFilters(aryFilters);
    //         break;
    // }

    const filterKey = 'f_' + name; 
    filters[filterKey] = value;    
    return queryString.stringify({...params, ...filters, ...sort})
}

export function updateVulScanSearchFilters(name, value) {

    const params = getLayoutParams();
    const sort = getSort();
    let filters = getFilters();

    let aryFilters=[];
    switch (name) {
    case 'status':
        aryFilters = ['type', 'scheduled'];
        filters = removeSearchFilters(aryFilters);
        break;                
    case 'type':
        aryFilters = ['status', 'scheduled'];
        filters = removeSearchFilters(aryFilters);
        break;
    case 'scheduled':
        aryFilters = ['type', 'status'];
        filters = removeSearchFilters(aryFilters);
        break;
    default:
        aryFilters = ['type', 'status', 'scheduled'];
        filters = removeSearchFilters(aryFilters);
        break;
    }

    const filterKey = 'f_' + name; 
    filters[filterKey] = value;    
    return queryString.stringify({...params, ...filters, ...sort})
}

export function removeSearchFilters(pfilters) {
    const aryFilters = pfilters.map(filter => 'f_' + filter);
    const filters = getFilters();

    aryFilters.forEach(filterToRemove => {
        delete filters[filterToRemove]
    });

    return ({...filters})
}


export function updateComparisonFilters(name, value) {
    const filterKey = 'f_' + name;
    const params = getLayoutParams();
    const sort = getSort();
    const filters = getComparisonFilters();
    filters[filterKey] = value;    
    return queryString.stringify({...params, ...filters, ...sort})
}

export function getComparisonFilters(clean) {
    const params = getParams();
    const result = Object.assign({});
    Object.keys(params)
        .filter(key => FILTER_REGEX.test(key))
        .forEach(key => result[clean ? key.slice(2) : key] = params[key]);
    return result;
}


// export function filtersToQuery(
//     query: Query,
//     filters: { [fieldName: string]: any }
//   ): Query {
//     Object.keys(filters).forEach((fieldName) => {
//       if (fieldName === 'sales_gte') {
//         query = query.where(fieldName.split('_')[0], '>=', filters[fieldName]);
//       } else if (fieldName === 'sales_lte') {
//         query = query.where(fieldName.split('_')[0], '<=', filters[fieldName]);
//       } else {
//         query = query.where(fieldName, '==', filters[fieldName]);
//       }
//     });
  
//     return query;
//   }




/**
 * Return pagination query params.
 *
 * @param clean {boolean} - remove pagination prefix from filter.
 * @return {object} - pagination params.
 */
export function getPagination(clean) {
    const params = getParams();
    const result = Object.assign({});
    Object.keys(params)
        .filter(key => PAGINATION_REGEX.test(key))
        .forEach(key => result[clean ? key.slice(2) : key] = params[key]);
    return result;
}

/**
 * Updates pagination params.
 *
 * @param page - page number.
 * @param size - page size.
 * @return {string} - query string.
 */
export function updatePagination(page, size) {
    const pageKey = 'p_page';
    const pageSizeKey = 'p_size';
    const params = getParams();
    params[pageKey] = page;
    params[pageSizeKey] = size;
    return queryString.stringify(params)
}

/**
 * Removes the filter by name.
 *
 * @param name - filter name.
 * @return {string} - query string.
 */
export function removeFilter(name) {
    const filterKey = 'f_' + name;
    const params = getLayoutParams();
    const sort = getSort();
    const filters = getFilters();

    if (filters[filterKey]) {
        delete filters[filterKey]
    }

    return queryString.stringify({...params, ...filters, ...sort})
}

/**
 * Removes the filters by name.
 *
 * @param array - filter name array.
 * @return {string} - query string.
 */
export function removeFilters(pfilters) {
    const aryFilters = pfilters.map(filter => 'f_' + filter);

    const params = getLayoutParams();
    const sort = getSort();
    const filters = getFilters();

    aryFilters.forEach(filterToRemove => {
        delete filters[filterToRemove]
    });

    return queryString.stringify({...params, ...filters, ...sort})
}
